import Caption from '@zenbusiness/common-components/Caption';
import { toUpper } from 'lodash';
import PropTypes from 'prop-types';

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import Grid from '@mui/material/Grid';

import { SavedIndicatorBox, StyledIconButton, TitleText } from './useStyles';

const LessonViewerHeader = ({
  title, backButtonClick, closeButtonClick, isSaving
}) => (
  <Grid container justifyContent="space-between">
    <Grid container item xs={10} justifyContent="flex-start" alignItems="center">
      <StyledIconButton
        onClick={backButtonClick}
        aria-label="back button"
        type="button"
        size="large"
      >
        <ArrowBackRoundedIcon sx={{ fontSize: '2rem' }} />
      </StyledIconButton>
      <TitleText size="md">{toUpper(title)}</TitleText>
      {isSaving && (
      <SavedIndicatorBox>
        <CheckRoundedIcon fontSize="small" />
        <Caption size="sm" color="focus60">Saved</Caption>
      </SavedIndicatorBox>
      )}
    </Grid>
    <Grid container item xs={2} justifyContent="flex-end" alignItems="center">
      <StyledIconButton
        onClick={closeButtonClick}
        aria-label="close button"
        type="button"
        size="large"
      >
        <CloseRoundedIcon />
      </StyledIconButton>
    </Grid>
  </Grid>
);

LessonViewerHeader.propTypes = {
  title: PropTypes.string.isRequired,
  backButtonClick: PropTypes.func.isRequired,
  closeButtonClick: PropTypes.func.isRequired,
  isSaving: PropTypes.bool
};

LessonViewerHeader.defaultProps = {
  isSaving: false
};

export default LessonViewerHeader;
